import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    Box, IconButton, Typography
} from "@mui/material";
import { toast } from "react-toastify";
import { read, utils } from 'xlsx';
import {
  UPLOAD_DOC_ACCEPT,
  validateUploadDocument,
} from "../../helper/uploadValidation";
import { getApiErrorMessage } from "../../helper/captcha";
import { 
  get_beneficiary, 
  get_beneficiary_by_id, 
  get_schemes_by_fy_added_pending, 
  uploadFile, 
  createSalary,
  getSalaryDetails,
  salaryApproval,
  send_otp,
  verify_otp,
  updateSalaryPayment
} from "../../helper/Api";
import Spinner from "../../components/Tools/spinner";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import SalaryActivityComponent from "./ActivityComponent";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { numberToWords, isValidURL } from '../../helper/Utils' 

const AddSalary = () => {
  const { authData, financialYears } = useSelector((state) => state.authData);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);
  const fy_list = financialYears.payload.fy_list;
  const fyIdRef = useRef(localStorage.getItem("globalDateId"));
  const [employees, setEmployees] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorAccountList, setVendorAccountList] = useState([]);
  const [scheme, setScheme] = useState([]);
  const [subhead_list, setSubhead_list] = useState([]);
  const [balanceUsed, SetBalanceUsed] = useState(0);
  const { id } = useParams();
  const { type } = useParams();
  const [view, setView] = useState(id ? true : false);
  const [init_payment, setInit_payment] = useState(0);
  const [otp, setOtp] = useState(null);
  const [bankDetails, setBankDetails] = useState({});
  const months = [
    { id: 1, month: "January" },
    { id: 2, month: "February" },
    { id: 3, month: "March" },
    { id: 4, month: "April" },
    { id: 5, month: "May" },
    { id: 6, month: "June" },
    { id: 7, month: "July" },
    { id: 8, month: "August" },
    { id: 9, month: "September" },
    { id: 10, month: "October" },
    { id: 11, month: "November" },
    { id: 12, month: "December" },
  ];
  const [formData, setFormData] = useState({
    salary_month: "", // required
    salary_type: "employee", // required
    voucher_date: "", // required
    sanction_order_date: "", // required
    voucher_no: "", // required
    sanction_order_no: "", // required
    voucher_url: "", // required
    sanction_order_url: "", // required
    scheme_id: "", // required
    subhead_id: "", // required
    subhead_amount: 0, // required
    financial_year_id: "", // required
    payable_amount: 0,
    gross_amount: 0, // required
    deduction_amount: 0,
    created_by: authData.user.id,
    agency_id: "", // required if salary_type=agency
    agency_account_id: "", // required if salary_type=agency
    gst_no: "",
    pan_no: "",
    bank: "",
    branch: "",
    ifsc_code: "",
    igst: "",
    sgst: "",
    cgst: "",
    invoice_value: "", // required if salary_type=agency
    taxable_amount: "", // required if salary_type=agency
    invoice_no: "", // required if salary_type=agency
    invoice_date: "", // required if salary_type=agency
    activities: [],
    employees: [], // length should be greater than 0
    l1_remark: "",
    l2_remark: "",
    l3_remark: "",
    l2_payment_status: "",
    l3_payment_status: "",
    l2_approval: "",
    l3_approval: "",
    payment_mode: ""
  });

  const approveSalary = async (status) => {
    try {
      formData.salary_id = id;
      if(authData.user.user_type === 'l2') {
        formData.l2_approval = status;
        delete formData.l3_approval;
        delete formData.l3_remark;
      } else if(authData.user.user_type === 'l3') {
        formData.l3_approval = status;
        delete formData.l2_approval;
        delete formData.l2_remark;
      }
      const res = await salaryApproval(formData);
      if(res.data.status) {
        setLoading(false);
        toast.success(res.data.message, {
          position: toast.POSITION.TOP_CENTER
        });
        navigate("/salary-approval");
      } else {
        setLoading(false);
        toast.error(res.data.message, {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }catch(error) {
      setLoading(false);
      toast.error(error.message, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  const handleSalaryApproval = async (e, status) => {
    e.preventDefault();
    setLoading(true);
    await approveSalary(status);
  }

  const initiate_payment = async (e) => {
      e.preventDefault();
      try {
          let mobile = authData.user.mobile;
          let otpIdentifier = 'salary-payment-approval';
          if (mobile) {
              let post_data = {
                  mobile: mobile,
                  identifier: otpIdentifier
              };

              const { data } = await send_otp(post_data);

              if (data.status) {
                  setInit_payment(1);
                  toast.success(data.message, {
                      position: toast.POSITION.TOP_CENTER
                  });
              } else {
                  toast.error(data.message, {
                      position: toast.POSITION.TOP_CENTER
                  });
              }
          }
      } catch (error) {
          toast.error("Code Error.Try Later !", {
              position: toast.POSITION.TOP_CENTER
          });
      }
  }

  const handlePayNow = async () => {
        try {
            let mobile = authData.user.mobile;
            let otpIdentifier = 'salary-payment-approval';
            if (mobile && otp && otpIdentifier) {
                let verify_data = {
                    mobile: mobile,
                    identifier: otpIdentifier,
                    otp: otp
                };
                // const { data } = await verify_otp(verify_data);
                const data = {status: true, message: 'OTP verified successfully'}; // Mocking OTP verification for testing
                if (data.status) {
                    toast.success(data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                    const {payment_mode} = formData;
                    const response = await updateSalaryPayment({
                        l2_payment_status: authData.user.user_type == 'l2' ? 1 : formData.l2_payment_status,
                        l3_payment_status: authData.user.user_type == 'l3' ? 1 : formData.l3_payment_status, 
                        payment_mode
                    }, id);
                    let response_data = response.data;
                    console.log(response_data);
                    if (response_data.status) {
                        toast.success(response_data.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                        setTimeout(function () {
                            window.location.href = "/salary-payment";
                        }, 1000);
                    } else {
                        toast.error(response_data.message, {
                            position: toast.POSITION.TOP_CENTER
                        });
                    }
                } else {
                    toast.error(data.message, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
        } catch (error) {
            toast.error('Code Error. Try Later.', {
                position: toast.POSITION.TOP_CENTER
            });
        }
    }


  const handleFormData = async (e) => {
    let name = e.target.name;
    let value = e.target.value;
    if(name === 'agency_id') {
      let vendor = vendorList.find(e => e.id === value);
      await fetchVendorAccountList(value);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        gst_no: vendor?.gst_no || "",
        pan_no: vendor?.pan_no || "",
      }));
    } else if(name === 'agency_account_id') {
      let account = vendorAccountList.find(e => e.id === value);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        ifsc_code: account?.ifsc_code || "",
        bank: account?.bank_name || "",
        branch: account?.branch_name || "",
      }));
    } else if(name === 'scheme_id') {
      await get_schemes_details(value, formData.financial_year_id);
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else if (name === 'cgst' || name === 'sgst' || name === 'igst') {
      setFormData((prev) => ({
      ...prev,
      [name]: value,
      invoice_value: Number(prev.gross_amount) + Number(value) + ((Number(prev.igst) + Number(prev.sgst) + Number(prev.cgst)) - Number(prev[name])),
    }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const employeeFormat = 'https://dev.uatesting.in/files/salary-emp-import-format.xlsx';

  const handleImport = ($event) => {
        const files = $event.target.files;
        formData.deduction_amount = 0;
        formData.gross_amount = 0;
        formData.payable_amount = 0;
        if (files.length) {
            const file = files[0];
            const reader = new FileReader();
            reader.onload = (event) => {
                const wb = read(event.target.result);
                const sheets = wb.SheetNames;

                if (sheets.length) {
                    const rows = utils.sheet_to_json(wb.Sheets[sheets[0]]);
                    const formattedArray = [];
                    rows.forEach(e => {
                        if(e['Emp name'] && e.Email && e.Address && e['ifsc code'] && e['Account No'] && e['Gross Amount']){
                            formattedArray.push({
                                code: e['Emp code'],
                                name: e['Emp name'],
                                mobile: e.Mobile,
                                email: e.Email,
                                address: e.Address,
                                ifsc: e['ifsc code'],
                                account_no: e['Account No'],
                                gross_amount: e['Gross Amount'],
                                deduction_amount: e['Deduction Amount'],
                                payable_amount: e['Payable Amount'],
                                gis_deduction: e['Gis Deduction'],
                                nps_deduction: e['NPS Deduction'],
                                other_deduction: e['Other Deduction'],
                                created_by: formData.created_by
                            });
                        }
                        let gis = Number(e['Gis Deduction'] ? e['Gis Deduction'] : 0);
                        let nps = Number(e['NPS Deduction'] ? e['NPS Deduction'] : 0);
                        let other = Number(e['Other Deduction'] ? e['Other Deduction'] : 0);
                        formData.deduction_amount += (gis + nps + other);
                        formData.gross_amount += Number(e['Gross Amount'] ? e['Gross Amount'] : 0);
                        formData.payable_amount += Number(e['Payable Amount'] ? e['Payable Amount'] : 0);
                    });

                    setEmployees(formattedArray)
                }
            }
            reader.readAsArrayBuffer(file);
        }
  }

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const fetch_list = async () => {
    const vendorResponse = await get_beneficiary({department_id: authData.user.department_id, type: 'agency'});
    if (vendorResponse.data.status) {
      setVendorList(vendorResponse.data.list);
    }
  }

  const fetchVendorAccountList = async (vendorId) => {
    const res = await get_beneficiary_by_id(vendorId);
    if (res.data.status) {
      setVendorAccountList(res.data.list[0].beneficiary_accounts)
    }
  }

  const get_schemes_details = async (scheme_id, financial_year, activities = [], subhead_id = null) => {
    setLoading(true);
    const { data } = await get_schemes_by_fy_added_pending(scheme_id, financial_year);
    if (data.status) {
      if (data.schemes.length > 0) {
        if (subhead_id && activities.length > 0) {
          const subhead = data.schemes[0].sub_heads_list.findIndex(e => e.id === subhead_id);
          if (subhead !== -1) {
            data.schemes[0].sub_heads_list[subhead].activity_budget.map(f => {
              f.balanceUsed = activities.find(a => Number(a.activity_id) === Number(f.subhead_activity_id) && Number(a.subactivity_id) === Number(f.subhead_subactivity_id))?.amount || 0;
            });
          }
        }
        setSubhead_list(data.schemes[0].sub_heads_list)
        setLoading(false);
      }
    }
  }
  const fetchSchenes = async () => {
    setLoading(true);
    const schemeResponse = await get_schemes_by_fy_added_pending();
    if (schemeResponse.data.status) {
      setScheme(schemeResponse.data.schemes);
      setLoading(false);
    }
  }
  

  useEffect(() => {
    fetch_list();
    fetchSchenes();
  }, [])

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      subhead_amount: balanceUsed,
    }))
  }, [balanceUsed]);

  const handleFileChange = async (event, keyName) => {
      try {
        const file = event.target.files[0];
        if (!file) {
          return;
        }
        const validation = validateUploadDocument(file);
        if (!validation.ok) {
          toast.error(validation.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          event.target.value = "";
          return;
        }
        const formData = new FormData();
        formData.append("doc", file);
        formData.append("folderName", "salary");
        const response = await uploadFile(formData);
        if(response.data.status) {
          setFormData(prev => ({
            ...prev,
            [keyName]: response.data.url,
          }))
        } else {
          toast.error(response.data.message || response.data.error || 'File upload failed', {
            position: toast.POSITION.TOP_CENTER,
          });
          event.target.value = "";
        }
      }catch(error) {
        event.target.value = "";
        toast.error(getApiErrorMessage(error, 'Something went wrong with file upload.'), {
            position: toast.POSITION.TOP_CENTER,
          });
      }
    };

    const renderFilePreview = (file, index, title="") => {
        const url = file?.url || '';
        const fileExtension = url.split('.')?.pop()?.toLowerCase();
        const isImage = ['jpg', 'jpeg', 'png'].includes(fileExtension);
        const isDocument = fileExtension === 'pdf';
        const validUrl = isValidURL(url);
        
        // Sanitize URL to prevent DOMXSS - ensure it's a safe http/https URL
        const sanitizeUrl = (urlString) => {
          try {
            const urlObj = new URL(urlString);
            // Only allow http and https protocols
            if (!['http:', 'https:'].includes(urlObj.protocol)) {
              return '';
            }
            return urlString;
          } catch (e) {
            return '';
          }
        };
        
        const safeUrl = sanitizeUrl(url);
        
        return (
          <Box key={index} sx={{ width: '100%', textAlign: 'center', marginRight: 2 }}>
            {validUrl && safeUrl ? (
              isImage ? (
                <img src={safeUrl} alt="preview" style={{ width: 150, height: 50, objectFit: 'cover', borderRadius: 8 }} />
              ) : isDocument ? (
                <a href={safeUrl} download style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                  <Box sx={{ width: '100%', height: 50, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f0f0f0', borderRadius: 0 }}>
                    {fileExtension === 'pdf' ? <PictureAsPdfIcon fontSize="large" color="error" /> : <InsertDriveFileIcon fontSize="large" color="primary" />}
                  </Box>
                </a>
              ) : (
                <Typography variant="body2">Attachment</Typography>
              )
            ) : (
              <Typography variant="body2" color="textSecondary">Invalid file</Typography>
            )}
            <Button color="error" size="small" variant="contained" onClick={() => handleRemove(index)} sx={{ mt: 1 }} style={{    background: "#e71818",
        padding: "1px 10px",
        fontSize: '10px',
        color: "#fff", marginTop: "2px"}} >
              Remove {title}
            </Button>
          </Box>
        );
      };


  const handleRemove = (index) => {
    // const newFiles = [...files];
    // newFiles.splice(index, 1);
    // setFiles(newFiles);
  };

  const MSG = {
    required: (f) => `${f} is required.`,
    mustBePositive: (f) => `${f} must be a non-negative number.`,
    mustBeGreaterEq: (a, b) => `${a} must be greater than or equal to ${b}.`,
    invalidFormat: (f) => `Invalid ${f} format.`,
    invalidDate: (f) => `${f} must be a valid date (YYYY-MM-DD).`,
    invalidMonth: (f) => `${f} must be a valid month (YYYY-MM).`,
    invalidURL: (f) => `${f} must be a valid URL (http/https).`,
    employeesMin: `At least one employee is required.`,
    taxEither: `Use either IGST or (CGST + SGST), not both.`,
    taxSplitMismatch: `CGST + SGST should be equal to IGST (when splitting).`,
    payableMismatch: `Payable amount should equal Gross - Deduction.`,
  };

  const isEmpty = (v) =>
    v === null || v === undefined || (typeof v === "string" && v.trim() === "");

  const isNumber = (v) => v !== "" && v !== null && v !== undefined && !isNaN(Number(v));
  const toNum = (v) => Number(v || 0);

  const isValidDateYMD = (v) => /^\d{4}-\d{2}-\d{2}$/.test(v) && !isNaN(new Date(v).getTime());
  const isValidMonthYYYYMM = (v) => /^\d{4}-(0[1-9]|1[0-2])$/.test(v);

  const isValidURL = (v) =>
    /^(https?:\/\/)([\w.-]+)(:[0-9]+)?(\/[^\s]*)?$/i.test(v);

  const isValidPAN = (v) => /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(v);
  const isValidIFSC = (v) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(v);

  const validateForm = (formData) => {
  const errors = [];

  // Required (always)
  if (isEmpty(formData.salary_month)) errors.push({ field: "salary_month", msg: MSG.required("Salary month") });
  if (isEmpty(formData.salary_type)) errors.push({ field: "salary_type", msg: MSG.required("Salary type") });
  if (isEmpty(formData.voucher_date)) errors.push({ field: "voucher_date", msg: MSG.required("Voucher date") });
  if (isEmpty(formData.sanction_order_date)) errors.push({ field: "sanction_order_date", msg: MSG.required("Sanction order date") });
  if (isEmpty(formData.voucher_no)) errors.push({ field: "voucher_no", msg: MSG.required("Voucher no") });
  if (isEmpty(formData.sanction_order_no)) errors.push({ field: "sanction_order_no", msg: MSG.required("Sanction order no") });
  if (isEmpty(formData.voucher_url)) errors.push({ field: "voucher_url", msg: MSG.required("Voucher URL") });
  if (isEmpty(formData.sanction_order_url)) errors.push({ field: "sanction_order_url", msg: MSG.required("Sanction order URL") });
  if (isEmpty(formData.scheme_id)) errors.push({ field: "scheme_id", msg: MSG.required("Scheme") });
  if (isEmpty(formData.subhead_id)) errors.push({ field: "subhead_id", msg: MSG.required("Subhead") });
  if (!isNumber(formData.subhead_amount) || toNum(formData.subhead_amount) < 0) errors.push({ field: "subhead_amount", msg: MSG.mustBePositive("Subhead amount") });
  if (isEmpty(formData.financial_year_id)) errors.push({ field: "financial_year_id", msg: MSG.required("Financial year") });
  if (!isNumber(formData.gross_amount) || toNum(formData.gross_amount) < 0) errors.push({ field: "gross_amount", msg: MSG.mustBePositive("Gross amount") });
  if (!isNumber(formData.deduction_amount) || toNum(formData.deduction_amount) < 0) errors.push({ field: "deduction_amount", msg: MSG.mustBePositive("Deduction amount") });
  if (!Array.isArray(formData.employees) || formData.employees.length === 0) {
    errors.push({ field: "employees", msg: MSG.employeesMin });
  }

  // URLs
  if (!isValidURL(formData.voucher_url)) {
    errors.push({ field: "voucher_url", msg: MSG.invalidURL("Voucher URL") });
  }
  if (!isValidURL(formData.sanction_order_url)) {
    errors.push({ field: "sanction_order_url", msg: MSG.invalidURL("Sanction order URL") });
  }

  // Amount relationships
  if (isNumber(formData.gross_amount) && isNumber(formData.deduction_amount)) {
    const gross = toNum(formData.gross_amount);
    const ded = toNum(formData.deduction_amount);
    if (ded > gross) {
      errors.push({ field: "deduction_amount", msg: MSG.mustBeGreaterEq("Gross amount", "Deduction amount") });
    }
    if (isNumber(formData.payable_amount)) {
      const payable = toNum(formData.payable_amount);
      if (payable !== gross - ded) {
        errors.push({ field: "payable_amount", msg: MSG.payableMismatch });
      }
    }
  }

  // Conditional (Agency)
  const isAgency = formData.salary_type === "agency";
  if (isAgency) {
    if (isEmpty(formData.agency_id)) errors.push({ field: "agency_id", msg: MSG.required("Agency") });
    if (isEmpty(formData.agency_account_id)) errors.push({ field: "agency_account_id", msg: MSG.required("Agency account") });
    if (isEmpty(formData.invoice_value) || !isNumber(formData.invoice_value) || toNum(formData.invoice_value) < 0) {
      errors.push({ field: "invoice_value", msg: MSG.mustBePositive("Invoice value") });
    }
    if (isEmpty(formData.taxable_amount) || !isNumber(formData.taxable_amount) || toNum(formData.taxable_amount) < 0) {
      errors.push({ field: "taxable_amount", msg: MSG.mustBePositive("Taxable amount") });
    }
    if (isEmpty(formData.invoice_no)) errors.push({ field: "invoice_no", msg: MSG.required("Invoice no") });
    if (isEmpty(formData.invoice_date) || !isValidDateYMD(formData.invoice_date)) {
      errors.push({ field: "invoice_date", msg: MSG.invalidDate("Invoice date") });
    }
  }

  return {
    valid: errors.length === 0,
    errors, // [{field, msg}]
  };
}

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      formData.employees = employees;
      formData.taxable_amount = formData.gross_amount;
      console.log(formData);
      const { valid, errors } = validateForm(formData);
      if (!valid) {
        // toast first error; optionally highlight fields using `errors` array
        toast.error(errors[0].msg, { position: toast.POSITION.TOP_CENTER });
        return;
      }
      const res = await createSalary(formData);
      toast.success("Salary created successfully", {
        position: toast.POSITION.TOP_CENTER
      });
      navigate("/salary-approval");
    }catch(error) {
      toast.error(error.message, {
          position: toast.POSITION.TOP_CENTER
      });
    }
  }

  const loadSalaryDetails = async (salaryId) => {
    try {
      const res = await getSalaryDetails(salaryId);
      if(res.data.status) {
        res.data.result.subhead_amount = Number(res.data.result.gross_amount) + Number(res.data.result.igst || 0) + Number(res.data.result.sgst || 0) + Number(res.data.result.cgst || 0);
        await get_schemes_details(res.data.result.scheme_id, res.data.result.financial_year_id, res.data.result.activities, res.data.result.subhead_id);
        setFormData(res.data.result);
        setEmployees(res.data.result.employees || []);
        setBankDetails(res.data.result.account_details || {});
      }
    }catch(error) {
      toast.error(error.message, {
        position: toast.POSITION.TOP_CENTER
      });
    }
  }

  useEffect(() => {
    if(id) {
      loadSalaryDetails(id);
    }
  }, [id])
  return (
    <div className="p-3">
      {loading && <div > <Spinner/> </div>}
      <div className="row" style={{ padding: "10px 16px" }}>
          <div className="col-md-6">
              <h4 style={{ color: "#28326f", margin:0}}>Add Salary</h4>
              <CustomBreadcrumbs linksArray={[{href:"/payroll-salary", label: 'Salary'}]} title="Add Salary"/>
          </div>
          <div className="col-md-6">
              
              <div className="m-0 p-0 d-flex gap-2" style={{ width: "auto", float: "right" }}>
                
                {!id && 
                <>
                  <a href={employeeFormat} className="p-2 d-flex justify-content-between align-items-center border-0 bg-secondary-50 text-white rounded-1" style={{textDecoration: 'none', cursor: 'pointer'}}>
                    <i className="icon-download"></i>
                    <span className="fs-12px">Salary Format</span>
                  </a>
                  <button type="button" className="submit_button" onClick={(e) => handleSubmit(e)} disabled={formData.salary_type !== 'agency' ? formData.gross_amount < formData.subhead_amount ? true : false : formData.invoice_value < formData.subhead_amount ? true : false}>
                      <span className="fs-14px">Save</span>
                  </button>
                </>
                 }
                {
                  ((authData.user.user_type === 'l2' && formData.l2_approval === null) || (authData.user.user_type === 'l3' && formData.l3_approval === null)) && <>
                  <button type="button" onClick={(e) => handleSalaryApproval(e, 0)} className="reject_button"> Reject</button>
                  <button type="button" onClick={(e) => handleSalaryApproval(e, 1)} className="submit_button"> Approve</button>
                  </>
                }
                {
                  Number(formData.l2_approval) === 1 && <button type="button" disabled className="btn btn-success">Approved By L2</button>
                }
                {
                  (authData.user.user_type === 'l2' && formData.l2_approval === "0") && <button type="button" disabled className="btn btn-success">Rejected By L2</button>
                }
                {
                  Number(formData.l3_approval) === 1 && <button type="button" disabled className="btn btn-success">Approved By L3</button>
                }
                {
                  (authData.user.user_type === 'l3' && formData.l3_approval === "0") && <button type="button" disabled className="btn btn-success">Rejected By L3</button>
                }
                

              </div>
          </div>
      </div>



      {/* ===================================body==================================== */}

      <div className="body m-0 bg-white p-2 rounded-3">
        <div className="row">
          <div className="col-6 d-flex flex-column gap-1">
            <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Salary Month *</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formData.salary_month || ""}
                    label="Salary Month *"
                    name="salary_month"
                    onChange={handleFormData}
                    disabled={view}
                >
                    {months.map((m) => (
                      <MenuItem key={m.id} value={m.id}>
                        {m.month}
                      </MenuItem>
                    ))}
                </Select>
            </FormControl>
          </div>
          <div className="col-6 d-flex align-items-center gap-4">
            <span className="fs-14px">Employee type</span>
            <div className="inputs m-0 p-0">
              <div className="m-0 p-0 d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="salary_type"
                  value="employee"
                  id="em"
                  checked={formData.salary_type === "employee"}
                  onChange={handleFormData}
                  disabled={view}
                />
                <label htmlFor="em" className="fs-12px">
                  Employee
                </label>
              </div>
            </div>
            {/* Consultant/Contractual */}
            <div className="inputs m-0 p-0">
              <div className="m-0 p-0 d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="salary_type"
                  id="cc"
                  value="consultant"
                  checked={formData.salary_type === "consultant"}
                  onChange={handleFormData}
                  disabled={view}
                />
                <label htmlFor="cc" className="fs-12px">
                  Consultant/Contractual
                </label>
              </div>
            </div>

            {/* Agency */}
            <div className="inputs m-0 p-0">
              <div className="m-0 p-0 d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="salary_type"
                  id="ag"
                  value="agency"
                  checked={formData.salary_type === "agency"}
                  onChange={handleFormData}
                  disabled={view}
                />
                <label htmlFor="ag" className="fs-12px">
                  Agency
                </label>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-5 d-flex flex-column gap-1">
            <FormControl fullWidth>
                <TextField 
                id="sanction_order_no"
                label="Sanction Order No" 
                variant="outlined" 
                type="text"
                name="sanction_order_no"
                value={formData.sanction_order_no || ""}
                onChange={handleFormData}
                // InputLabelProps={{ shrink: view ? true : false }}
                required
                disabled={view}
                />
            </FormControl>
          </div>
          <div className="col-5 d-flex flex-column gap-1">
            <FormControl fullWidth>
                <TextField
                    type="date"
                    id="sanction_order_date"
                    label="Sanction Order Date"
                    name="sanction_order_date"
                    value={formData.sanction_order_date || ""}
                    onChange={handleFormData}
                    InputLabelProps={{ shrink: true }}
                    required
                    disabled={view}
                />
            </FormControl>
          </div>

          <div className="col-2 m-0 p-0 d-flex align-items-center position-relative overflow-hidden mt-1">
            {formData.sanction_order_url && renderFilePreview({url: formData.sanction_order_url}, 1, 'Sanction Order')}
            {
              !formData.sanction_order_url && <>
              <input
                type="file"
                id="pdf"
                className="border w-100 border-danger position-absolute mx-2 py-2 opacity-0 cursor-pointer scale "
                style={{ scale: "3", left: "-70%" }}
                onChange={e => handleFileChange(e, 'sanction_order_url')}
                accept={UPLOAD_DOC_ACCEPT}
              />
              <div className="row d-flex align-items-center m-0 p-0 border w-100 mx-2 px-3 py-1">
                <div className="col-2 m-0 p-0 d-flex align-items-center">
                  <i className="icon-upload fs-20px"></i>
                </div>
                <div className="col-10 d-flex flex-column justify-content-center align-items-start m-0 p-0 fs-14px ps-2">
                  <span className="text-start">Sanction Order</span>
                  <span className="text-black-30 fs-12px">(PDF/JPG/PNG upto 5MB)</span>
                </div>
              </div>
            </>
            }
            
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-5 d-flex flex-column gap-1">
            <FormControl fullWidth>
                <TextField 
                id="voucher_no"
                label="Voucher No" 
                variant="outlined" 
                type="text"
                name="voucher_no"
                value={formData.voucher_no || ""}
                // InputLabelProps={{ shrink: view ? true : false }}
                onChange={handleFormData}
                disabled={view}
                required
                />
            </FormControl>
          </div>
          <div className="col-5 d-flex flex-column gap-1">
            <FormControl fullWidth>
                <TextField
                    type="date"
                    id="voucher_date"
                    label="Voucher Date"
                    name="voucher_date"
                    value={formData.voucher_date || ""}
                    onChange={handleFormData}
                    InputLabelProps={{ shrink: true }}
                    disabled={view}
                    required
                />
            </FormControl>
          </div>

          <div className="col-2 m-0 p-0 d-flex align-items-center position-relative overflow-hidden mt-1">
            {formData.voucher_url && renderFilePreview({url: formData.voucher_url}, 1, 'Voucher Order')}
            {
              !formData.voucher_url && <>
              <input
                type="file"
                id="pdf"
                className="border w-100 border-danger position-absolute mx-2 py-2 opacity-0 cursor-pointer scale "
                style={{ scale: "3", left: "-70%" }}
                onChange={e => handleFileChange(e, 'voucher_url')}
                accept={UPLOAD_DOC_ACCEPT}
              />
              <div className="row d-flex align-items-center m-0 p-0 border w-100 mx-2 px-3 py-1">
                <div className="col-2 m-0 p-0 d-flex align-items-center">
                  <i className="icon-upload fs-20px"></i>
                </div>
                <div className="col-10 d-flex flex-column justify-content-center align-items-start m-0 p-0 fs-14px ps-2">
                  <span className="text-start">Voucher Order</span>
                  <span className="text-black-30 fs-12px">(PDF/JPG/PNG upto 5MB)</span>
                </div>
              </div>
            </>
            }
          </div>
        </div>
      </div>

      {formData.salary_type === "agency" && (
        <div className="body m-0 bg-white p-2 rounded-3 mt-3">
          <span className="fs-18px my-3 px-1 py-2">Agency Details</span>
          <div className="row mt-2">
            <div className="col-4 d-flex flex-column gap-1">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Agency *</InputLabel>
                <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={formData.agency_id || ""}
                    label="Agency *"
                    name="agency_id"
                    onChange={handleFormData}
                    disabled={view}
                >
                    {vendorList.map((m) => (
                      <MenuItem key={m.id} value={m.id}>
                        {m.company_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>

            <div className="col-4 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="gst_no"
                  label="GST No" 
                  variant="outlined"
                  value={formData.gst_no || ""}
                  type="text"
                  name="gst_no"
                  disabled
                  required
                  />
              </FormControl>
            </div>

            <div className="col-4 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="pan_no"
                  label="Pan Card No" 
                  variant="outlined" 
                  type="text"
                  name="pan_no"
                  value={formData.pan_no || ""}
                  disabled
                  required
                  />
              </FormControl>
            </div>

            <div className="col-3 d-flex flex-column gap-1 mt-2">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-account">Account *</InputLabel>
                <Select
                    labelId="demo-simple-select-account"
                    id="demo-simple-select"
                    value={formData.agency_account_id || ""}
                    label="Account *"
                    name="agency_account_id"
                    onChange={handleFormData}
                    disabled={view}
                >
                    {vendorAccountList.map((m) => (
                      <MenuItem key={m.id} value={m.id}>
                        {m.bank_name} {m.account_no}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </div>

            <div className="col-3 d-flex flex-column gap-1 mt-2">
              <FormControl fullWidth>
                  <TextField 
                  id="ifsc"
                  label="IFSC Code"
                  value={formData.ifsc_code || ""}
                  InputLabelProps={{ shrink: true }}
                  variant="outlined" 
                  type="text"
                  name="ifsc_code"
                  disabled
                  required
                  />
              </FormControl>
            </div>

            <div className="col-3 d-flex flex-column gap-1 mt-2">
              <FormControl fullWidth>
                  <TextField 
                  id="bank"
                  label="Bank" 
                  variant="outlined" 
                  type="text"
                  name="bank"
                  value={formData.bank || ""}
                  InputLabelProps={{ shrink: true }}
                  inl
                  disabled
                  required
                  />
              </FormControl>
            </div>

            <div className="col-3 d-flex flex-column gap-1 mt-2">
              <FormControl fullWidth>
                  <TextField 
                  id="branch"
                  label="Branch Name" 
                  variant="outlined" 
                  type="text"
                  name="branch"
                  value={formData.branch || ""}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  required
                  />
              </FormControl>
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-5 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="invoice_no"
                  label="Invoice No" 
                  variant="outlined" 
                  type="text"
                  name="invoice_no"
                  value={formData.invoice_no || ""}
                  onChange={handleFormData}
                  required={formData.salary_type === "agency" ? true : false}
                  disabled={view}
                  />
              </FormControl>
            </div>
            <div className="col-5 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="invoice_date"
                  label="Invoice Date" 
                  variant="outlined" 
                  type="date"
                  name="invoice_date"
                  value={formData.invoice_date || ""}
                  InputLabelProps={{ shrink: true }}
                  onChange={handleFormData}
                  required={formData.salary_type === "agency" ? true : false}
                  disabled={view}
                  />
              </FormControl>
            </div>

            <div className="col-2 m-0 p-0 d-flex align-items-center position-relative overflow-hidden mt-1">
              {formData.invoice_url && renderFilePreview({url: formData.invoice_url}, 1, 'Invoice Order')}
              {
                !formData.invoice_url && <>
                <input
                  type="file"
                  id="pdf"
                  className="border w-100 border-danger position-absolute mx-2 py-2 opacity-0 cursor-pointer scale "
                  style={{ scale: "3", left: "-70%" }}
                  onChange={e => handleFileChange(e, 'invoice_url')}
                  accept={UPLOAD_DOC_ACCEPT}
                />
                <div className="row d-flex align-items-center m-0 p-0 border w-100 mx-2 px-3 py-1">
                  <div className="col-2 m-0 p-0 d-flex align-items-center">
                    <i className="icon-upload fs-20px"></i>
                  </div>
                  <div className="col-10 d-flex flex-column justify-content-center align-items-start m-0 p-0 fs-14px ps-2">
                    <span className="text-start">Upload Invoice</span>
                    <span className="text-black-30 fs-12px">(PDF/JPG/PNG upto 5MB)</span>
                  </div>
                </div>
              </>
              }
            </div>
          </div>

          <div className="row mt-2">
            <div className="col-3 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="taxabale"
                  label="Taxable Amount" 
                  variant="outlined" 
                  type="text"
                  value={formData.gross_amount || ""}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  />
              </FormControl>
            </div>
            <div className="col-2 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="gst_deduction"
                  label="IGST" 
                  variant="outlined" 
                  type="text"
                  value={formData.igst || ""}
                  name="igst"
                  onChange={handleFormData}
                  disabled={view}
                  />
              </FormControl>
            </div>

            <div className="col-2 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="sgst_deduction"
                  label="SGST" 
                  variant="outlined" 
                  type="text"
                  value={formData.sgst || ""}
                  name="sgst"
                  onChange={handleFormData}
                  disabled={view}
                  />
              </FormControl>
            </div>
            <div className="col-2 d-flex flex-column gap-1">
              <FormControl fullWidth>
                  <TextField 
                  id="cgst_deduction"
                  label="CGST" 
                  variant="outlined" 
                  type="text"
                  value={formData.cgst || ""}
                  name="cgst"
                  onChange={handleFormData}
                  disabled={view}
                  />
              </FormControl>
            </div>

            <div className="col-3 d-flex flex-column gap-1 p-0 m-0">
              <FormControl fullWidth>
                  <TextField 
                  id="invoice_value"
                  label="Invoice Value" 
                  variant="outlined" 
                  type="text"
                  value={formData.invoice_value || ""}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  required
                  />
              </FormControl>
            </div>
          </div>
        </div>
      )}

      {/* ====================================================================================== */}

      <div className="header d-flex justify-content-between align-items-center my-3">
        <span className="fs-18px">Employee Details </span>

        <div className="m-0 p-0 d-flex align-items-center gap-2">
          <button
            onClick={handleClick}
            disabled={view}
            style={{
              backgroundColor: "#FFC107",
              color: "black",
              border: "none",
              padding: "10px 20px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "500",
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              gap: "8px"
              
            }}
          >
            <i className="icon-upload"></i> Salary Data
          </button>

          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleImport}
            accept=".xlsx,.csv"
          />
        </div>
      </div>

      <div
        className="m-0 p-0 d-flex flex-column gap-1 "
        style={{ maxHeight: "350px", overflowY: "scroll" }}
      >
        {employees.map(e =>
          <>
            <div className="bg-white rounded-3">
              <div className="row p-0 m-0">
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Employee Code</span>
                  <span className="fw-500 fs-14px">{e.code}</span>
                </div>
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Employee Name</span>
                  <span className="fw-500 fs-14px">{e.name}</span>
                </div>
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Mobile No*</span>
                  <span className="fw-500 fs-14px">{e.mobile}</span>
                </div>
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Email</span>
                  <span className="fw-500 fs-14px">{e.email}</span>
                </div>
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">IFSC Code</span>
                  <span className="fw-500 fs-14px">{e.ifsc}</span>
                </div>
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Account no.</span>
                  <span className="fw-500 fs-14px">{e.account_no}</span>
                </div>
                <div className="col d-flex flex-column py-2">
                  <span className="text-black-60 fs-12px">Address</span>
                  <span className="fw-500 fs-14px">{e.address}</span>
                </div>
              </div>
              <div className="m-0 p-0 d-flex gap-4 justify-content-end px-2">
                <div className="d-flex py-2 gap-1 align-items-center">
                  <span className="text-prime-100 fs-12px d-flex justify-content-between align-items-center">
                    Gross Amount:
                  </span>
                  <span className="fw-500 fs-14px d-flex align-items-center">
                    {e.gross_amount}
                  </span>
                </div>

                <div className="d-flex py-2 gap-1 ">
                  <span className="text-danger-100 fs-12px d-flex justify-content-between align-items-center">
                    GIS Deduction:
                  </span>
                  <span className="fw-500 fs-14px d-flex align-items-center">
                    {e.gis_deduction}
                  </span>
                </div>

                <div className="d-flex py-2 gap-1 ">
                  <span className="text-danger-100 fs-12px d-flex justify-content-between align-items-center">
                    NPS Deduction:
                  </span>
                  <span className="fw-500 fs-14px d-flex align-items-center">
                    {e.nps_deduction}
                  </span>
                </div>
                <div className="d-flex py-2 gap-1 ">
                  <span className="text-danger-100 fs-12px d-flex justify-content-between align-items-center">
                    Other Deduction:
                  </span>
                  <span className="fw-500 fs-14px d-flex align-items-center">
                    {e.other_deduction}
                  </span>
                </div>
                <div className="d-flex py-2 gap-1 ">
                  <span className="text-success-100 fs-12px d-flex justify-content-between align-items-center">
                    Net Salary Payable:
                  </span>
                  <span className="fw-500 fs-14px d-flex align-items-center">
                    {e.payable_amount}
                  </span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>

      <div
          className=" m-0 p-0 p-2 mt-3 bg-success-20 d-flex justify-content-between align-items-center"
          style={{ border: "1px solid #198754" }}
        >
          <span>
            <span className="fs-12px text-black-60">Total Gross Income: </span>
            <span className="fs-14px fw-500">{Number(formData.gross_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </span>
          <span>
            <span className="fs-12px text-black-60">
              Total Deduction Amount:{" "}
            </span>
            <span className="fs-14px fw-500">{Number(formData.deduction_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </span>
          <span>
            <span className="fs-12px text-black-60">
              Total Payment Amount:{" "}
            </span>
            <span className="fs-14px fw-500">{Number(formData.payable_amount).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </span>
        </div>

      <div className="details my-3 fs-18px">Scheme Details</div>
      <div className="bg-white">
        <div className="row p-2">
          <div className="col-2 d-flex flex-column gap-1">
            <FormControl fullWidth>
              <InputLabel id="fy">Financial Year *</InputLabel>
              <Select
                  labelId="fy"
                  id="fy"
                  value={formData.financial_year_id || ""}
                  label="Financial Year *"
                  name="financial_year_id"
                  onChange={handleFormData}
                  disabled={view}
              >
                  {fy_list?.map((m) => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.start_year}-{m.end_year}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-3 d-flex flex-column gap-1">
            <FormControl fullWidth>
              <InputLabel id="scheme">Scheme *</InputLabel>
              <Select
                  labelId="scheme"
                  id="scheme"
                  value={formData.scheme_id || ""}
                  label="Scheme *"
                  name="scheme_id"
                  onChange={handleFormData}
                  disabled={!formData.financial_year_id || view}
              >
                  {scheme?.map((m) => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-3 d-flex flex-column gap-1">
            <FormControl fullWidth>
              <InputLabel id="subhead">Subhead *</InputLabel>
              <Select
                  labelId="subhead"
                  id="subhead"
                  value={formData.subhead_id || ""}
                  label="Subhead *"
                  name="subhead_id"
                  onChange={handleFormData}
                  disabled={!formData.scheme_id || view}
              >
                  {subhead_list?.map((m) => (
                    <MenuItem key={m.id} value={m.id}>
                      {m.name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </div>
          <div className="col-2 d-flex gap-1">
            <FormControl fullWidth>
                  <TextField 
                  id="subhead_balance"
                  label="Subhead Balance" 
                  variant="outlined" 
                  type="text"
                  value={formData.subhead_id && subhead_list?.find(e => e.id === formData.subhead_id)?.balance}
                  disabled
                  required
                  />
              </FormControl>
          </div>
          <div className="col-2 d-flex gap-1">
            <FormControl fullWidth>
                  <TextField 
                  id="subhead_amount"
                  label="Subhead Amount" 
                  variant="outlined" 
                  type="number"
                  name="subhead_amount"
                  value={formData.subhead_amount}
                  InputLabelProps={{ shrink: true }}
                  disabled={(formData.subhead_id && subhead_list?.find(e => e.id === formData.subhead_id)?.activity_budget.length > 0) || view}
                  error={formData.salary_type !== 'agency' ? formData.gross_amount < formData.subhead_amount ? true : false : formData.invoice_value < formData.subhead_amount ? true : false}
                  helperText={formData.salary_type !== 'agency' ? formData.gross_amount < formData.subhead_amount ? `Subhead Amount greater then gross amount` : "" : formData.invoice_value < formData.subhead_amount ? `Subhead Amount greater then invoice value` : ""}
                  onChange={(formData.subhead_id && subhead_list?.find(e => e.id === formData.subhead_id)?.activity_budget.length === 0) && handleFormData}
                  required
                  />
              </FormControl>
          </div>
        </div>

        {
          (formData.subhead_id && subhead_list?.find(e => e.id === formData.subhead_id)?.activity_budget.length > 0) && <SalaryActivityComponent activities={subhead_list.find(e => e.id === formData.subhead_id).activity_budget} SetBalanceUsed={SetBalanceUsed} setFormData={setFormData} view={view}/>
        }
        <div className="row p-0 m-0 p-2 d-flex justify-content-between">
          <div className="col-6 m-0">
            <FormControl fullWidth>
                  <TextField 
                  id="l1_remark"
                  label="L1 Remark" 
                  variant="outlined" 
                  type="text"
                  name="l1_remark"
                  value={formData.l1_remark || ""}
                  onChange={handleFormData}
                  disabled={view}
                  // InputLabelProps={{ shrink: view ? true : false }}
                  required
                  />
              </FormControl>
          </div>
          <div className="col-6 m-0">
            <FormControl fullWidth>
                  <TextField 
                  id="l2_remark"
                  label="L2 Remark" 
                  variant="outlined" 
                  type="text"
                  name="l2_remark"
                  value={formData.l2_remark || ""}
                  onChange={handleFormData}
                  disabled={authData.user.user_type !== 'l2'}
                  // InputLabelProps={{ shrink: view ? true : false }}
                  
                  />
              </FormControl>
          </div>

          <div className="col-6 m-0 mt-3">
            <FormControl fullWidth>
                  <TextField 
                  id="l3_remark"
                  label="L3 Remark" 
                  variant="outlined" 
                  type="text"
                  name="l3_remark"
                  value={formData.l3_remark || ""}
                  onChange={handleFormData}
                  disabled={authData.user.user_type !== 'l3'}
                  // InputLabelProps={{ shrink: view ? true : false }}
                  />
              </FormControl>
          </div>
          {
            type && type === 'payment' && <>
            <div className="col-12">
              <hr />
            </div>
            {
                ((authData.user.user_type === 'l2' && formData.l2_payment_status === null) || (authData.user.user_type === 'l3' && formData.l3_payment_status === null)) && <>
                  <div className="col-6 m-0 mt-3">
                  <p><strong>Account Name:</strong> {bankDetails?.account_name}</p>
                  <p><strong>Bank Name:</strong> {bankDetails?.bank_name}</p>
                  <p><strong>Branch:</strong> {bankDetails?.branch_name}</p>
                  <p><strong>Account Type:</strong> {bankDetails?.account_type}</p>
                  <p><strong>Account No:</strong> {bankDetails?.account_no}</p>
                  <p><strong>IFSC:</strong> {bankDetails?.ifsc_code}</p>
                  <p><strong>Total Amount To Pay:</strong> {formData.invoice_value == 0 ? formData.gross_amount : formData.invoice_value}</p>
                  <p><strong>Amount in Words:</strong> {numberToWords(formData.invoice_value == 0 ? formData.gross_amount : formData.invoice_value)}</p>
                </div>
                <div className="col-6 m-0 mt-3">
                  
                  <button type="button" className='btn btn-primary me-lg-2'
                  onClick={initiate_payment}
                  > Initiate Payment</button>
                  <hr />
                  <div className='row'>
                      <div className='col-md-4'>
                          <label>Payment Mode : </label>
                      </div>
                      <div className='col-md-8'>
                          <p><input type="radio" value="offline" name="payment_mode" 
                          checked={formData.payment_mode === 'offline'} 
                          onChange={handleFormData} /> Offline</p>
                          <p><input type="radio" value="online" name="payment_mode" checked={formData.payment_mode === 'online'} onChange={handleFormData}/> Online</p>
                      </div>
                  </div>
                  <input type="number" className='form-control my-2' placeholder='Enter Otp' 
                  onChange={(e) => setOtp(e.target.value)} value={otp} disabled={!init_payment}
                  />
                  <button type="button" className='btn btn-success' 
                  disabled={otp ? false : true} onClick={handlePayNow}
                  > Approve Payment</button>
                </div>
                </>
            }
            
            </>
          }
          

        </div>
      </div>
    </div>
  );
};

export default AddSalary;
